import React from 'react'
import { FunctionComponent, ReactNode } from 'react'
import E3DShareIcon from '../../../assets/media/icons/e3d-share.svg'
import navigationStyle from '../../navigation/navigation.css'
import useTranslation from '../../../hooks/useTranslation'

export type Props = {
  isLoggedIn: boolean
  isLoading: boolean
  loginStatus: 'none' | 'loading' | 'success' | 'error'
  openE3DModal: () => void
  isDisabled?: boolean
  tooltipText?: string
  brand: string
}

const E3DButton: FunctionComponent<Props> = ({
  isLoading,
  loginStatus,
  openE3DModal,
  isDisabled ,
  tooltipText,
  brand,
}) => {
  const { t } = useTranslation()

  const createTrafficLightElement = (status: 'none' | 'loading' | 'success' | 'error'): ReactNode => {
    const statusClassMap = {
      'none': navigationStyle.trafficLightNone,
      'loading': navigationStyle.trafficLightIncomplete,
      'success': navigationStyle.trafficLightDone,
      'error': navigationStyle.trafficLightError,
    }

    return <div className={`${navigationStyle.trafficLight} ${statusClassMap[status]}`} />
  }

  const displayStatus = isLoading ? 'loading' : loginStatus

  const createIconElement = (): ReactNode => {
    return <E3DShareIcon className={navigationStyle.icon} />
  }

  const createLabelElement = (): ReactNode => {
    return (
      <div className={navigationStyle.labelActive}>
        {t(`e3d.${brand}.shareThisVehicle`)}
      </div>
    )
  }

  const content = (
    <>
      {createIconElement()}
      {createLabelElement()}
      {createTrafficLightElement(displayStatus)}
    </>
  )

  return (
    <button
      className={navigationStyle.link}
      onClick={openE3DModal}
      data-testid="e3d-share-button"
      disabled={isDisabled}
      title={tooltipText}
      style={{
        border: 'none',
        background: 'none',
        width: '100%',
        textAlign: 'left',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        opacity: isDisabled ? 0.6 : 1,
      }}
    >
      {content}
    </button>
  )
}

export default E3DButton
